import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { AuthAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = checking, false = anon, object = authed
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    const token = localStorage.getItem('pn_token');
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const me = await AuthAPI.me();
      setUser(me);
    } catch {
      localStorage.removeItem('pn_token');
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (email, password) => {
    const data = await AuthAPI.login(email, password);
    localStorage.setItem('pn_token', data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('pn_token');
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, ready, login, logout, refresh: check }),
    [user, ready, login, logout, check],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
